// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__DetailsPage__cpAcccordionHeader{align-items:center;display:flex}.app__DetailsPage__cpDetailsBuildingIcon{justify-self:left}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/twia-capability-fnol-cp-react/pages/Details/DetailsPage.module.scss"],"names":[],"mappings":"AAAA,sCAEE,kBAAA,CADA,YACA,CAGF,yCACE,iBAAA","sourcesContent":[".cpAcccordionHeader {\n  display: flex;\n  align-items: center;\n}\n\n.cpDetailsBuildingIcon {\n  justify-self: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cpAcccordionHeader": "app__DetailsPage__cpAcccordionHeader",
	"cpDetailsBuildingIcon": "app__DetailsPage__cpDetailsBuildingIcon"
};
export default ___CSS_LOADER_EXPORT___;
